module.exports = __webpack_public_path__ + "img/battle-ropes-in-sand.8156e0d1.jpg";